<template>
  <div>
    <common-dialog
      ref="dialog"
      width="860px"
      unit="往来单位"
      edit-title
      show-save-button
      id-key="TradeUnitId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreate"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="往来单位编码" label-width="110px" prop="TradeUnitNo">
              <!-- <el-input type="text" v-model="data.TradeUnitNo" placeholder="请输入往来单位编码"></el-input> -->
              <span v-if="Mode == 0" class="detail-span">{{ data.TradeUnitNo }}</span>
              <el-input v-else v-model="data.TradeUnitNo" placeholder="请输入往来单位编码"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="往来单位名称" label-width="110px" prop="FullName">
              <el-input type="text" v-model="data.FullName" placeholder="请输入往来单位名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="简称" label-width="110px" prop="ShortName">
              <el-input type="text" v-model="data.ShortName" placeholder="请输入简称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性质" label-width="110px" prop="TradeUnitType">
              <el-select v-model="data.TradeUnitType" @change="setting">
                <el-option v-if="data.loginInfo.QxKh" :value="0" label="客户"></el-option>
                <el-option v-if="data.loginInfo.QxGys" :value="1" label="供应商"></el-option>
                <el-option v-if="data.loginInfo.QxKhGys":value="2" label="客户&供应商"></el-option>
                <el-option v-if="data.loginInfo.QxWx" :value="3" label="外协"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属分类" label-width="110px" prop="ClassId">
              <tree-select
                ref="classTreeSelect"
                :props="ClassProps"
                :options="ClassTreeData"
                :value="data.ClassId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onClassTreeSelect($event)"
              />
              <!-- <el-select v-model="data.ClassId">
                <el-option v-for="item in ClassTreeData" :key="item.ClassId" :value="item.ClassId" :label="item.ClassName">
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('Come', 'SettleUnitId')">
            <el-form-item label="结算单位" label-width="110px">
              <el-select v-model="data.SettleUnitId" :disabled="is_SettleUnit">
                <el-option v-for="item in unitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!--  -->
          <el-tab-pane label="基本信息" name="baseData">
            <div class="baseData-title"><b>基本信息</b></div>
            <el-row>
              <el-col :span="12" v-if="iShow('Base', 'Code')">
                <el-form-item label="助记码" label-width="110px">
                  <el-input type="text" v-model="data.Code" placeholder="请输入助记码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="建档日期" label-width="110px" prop="CreatedDate">
                  {{ data.CreatedDate }}
                  <!-- <el-date-picker
                    v-model="data.CreatedDate"
                    type="date"
                    placeholder="选择日期"
                  /> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分管部门" label-width="110px" prop="DpId">
                  <!-- <dp-select v-model="data.DpId"></dp-select> -->
                  <tree-select
                    ref="dpTreeSelect"
                    :props="DpProps"
                    :options="DpTreeData"
                    :value="data.DpId"
                    :clearable="false"
                    :accordion="true"
                    :parentSelect="true"
                    placeholder="请选择"
                    @node-select="onDpTreeSelect($event)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分管人员" label-width="110px" prop="EmpId">
                  <!-- <employee-select v-model="data.EmpId"></employee-select> -->
                  <el-select v-model="data.EmpId">
                    <el-option v-for="item in employeeList" :key="item.EmpId" :value="item.EmpId" :label="item.EmpName"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地区" label-width="110px" prop="DistrictId">
                  <!-- <area-select v-model="data.DistrictId"></area-select> -->
                  <tree-select
                    ref="areaTreeSelect"
                    :props="AreaProps"
                    :options="AreaTreeData"
                    :value="data.DistrictId"
                    :clearable="false"
                    :accordion="true"
                    :parentSelect="true"
                    placeholder="请选择"
                    @node-select="onAreaTreeSelect($event)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'LineOfCredit')">
                <el-form-item label="信用额度" label-width="110px">
                  <el-input type="number" v-model="data.LineOfCredit" placeholder="请输入信用额度"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="渠道" label-width="110px" prop="ChannelId">
                  <ditch-select v-model="data.ChannelId"></ditch-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="notBottom">
                  <el-checkbox v-model="data.Status" :true-label="0" :false-label="1" v-if="iShow('Base', 'Status')">停用 </el-checkbox>
                  <el-checkbox v-model="data.AutoWriteOff" v-if="iShow('Base', 'AutoWriteOff')">参与自动核销</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="baseData-title"><b>注册信息</b></div>
            <el-row>
              <el-col :span="12" v-if="iShow('Base', 'Legal')">
                <el-form-item label="法人代表" label-width="110px">
                  <el-input type="number" v-int v-model="data.Legal" placeholder="请输入法人代表"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'DepositBank')">
                <el-form-item label="开户银行" label-width="110px">
                  <el-input type="text" v-model="data.DepositBank" placeholder="请输入开户银行"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号" label-width="110px" prop="Account">
                  <el-input type="number" v-int v-model="data.Account" placeholder="请输入账号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'TaxNo')">
                <el-form-item label="纳税号" label-width="110px">
                  <el-input type="number" v-int v-model="data.TaxNo" placeholder="请输入纳税号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'CollectionScatter')">
                <el-form-item label="集合零散" label-width="110px">
                  <el-select v-model="data.CollectionScatter">
                    <el-option :value="0" label="否"></el-option>
                    <el-option :value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'IsMember')">
                <el-form-item label="会员账号" label-width="110px">
                  <el-select v-model="data.IsMember">
                    <el-option :value="0" label="否"></el-option>
                    <el-option :value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="baseData-title"><b>价税信息</b></div>
            <el-row>
              <el-col :span="12" v-if="iShow('Base', 'IsIncludeTax')">
                <el-form-item label="供应商报价含税" label-width="110px">
                  <el-select v-model.number="data.IsIncludeTax" placeholder="请选择供应商报价含税">
                    <el-option key="IsIncludeTax1" label="否" :value="0"></el-option>
                    <el-option key="IsIncludeTax2" label="是" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="税率%" label-width="110px" prop="TaxRate" v-if="data.IsIncludeTax == 1">
                  <el-input type="number" v-model="data.TaxRate" placeholder="请输入税率"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="baseData-title" v-show="false"><b>余额信息</b></div>
            <el-row v-show="false">
              <el-col :span="12" v-if="iShow('Base', 'BaseCopeWith')">
                <el-form-item label="应收余额" label-width="110px">
                  <!-- <el-input type="number" v-int v-model="data.No" placeholder="请输入应收余额"></el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'BasePrecollected')">
                <el-form-item label="预收余额" label-width="110px">
                  <!-- <el-input type="number" v-int v-model="data.No" placeholder="请输入预收余额"></el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'Code')">
                <el-form-item label="应付余额" label-width="110px">
                  <!-- <el-input type="number" v-int v-model="data.No" placeholder="请输入应付余额"></el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Base', 'BasePrepay')">
                <el-form-item label="预付余额" label-width="110px">
                  <!-- <el-input type="number" v-int v-model="data.No" placeholder="请输入预付余额"></el-input> -->
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- 客户设置 -->
          <el-tab-pane label="客户设置" name="client" v-if="data.TradeUnitType == 0 || data.TradeUnitType == 2">
            <el-row>
              <el-col :span="12">
                <el-form-item label="默认结算方式" label-width="110px" prop="CollectionSet.SettleId">
                  <!-- <el-select v-model="data.CollectionSet.SettleId">
                    <el-option :value="0" label="客户"></el-option>
                    <el-option :value="1" label="甲方"></el-option>
                  </el-select> -->
                  <settle-select v-model="data.CollectionSet.SettleId" @change="v => (data.PaymentSet.SettleId = v)"></settle-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认账号" label-width="110px" prop="CollectionSet.AccnoutId">
                  <account-select v-model="data.CollectionSet.AccnoutId" @change="v => (data.PaymentSet.AccnoutId = v)"></account-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认票据类型" label-width="110px" prop="CollectionSet.InvoiceType">
                  <invoice-select v-model="data.CollectionSet.InvoiceType" @change="v => (data.PaymentSet.InvoiceType = v)"></invoice-select>
                  <!-- <el-select v-model="data.CollectionSet.InvoiceType">
                    <el-option :value="0" label="客户"></el-option>
                    <el-option :value="1" label="甲方"></el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
            </el-row>
            <div class="payWay">
              <strong class="payWay-title">默认收款方式</strong>
              <div class="payWay-group">
                <el-row class="payWay-item">
                  <el-radio v-model="data.CollectionSet.CollectionType" :label="1"><span class="payWay-item_label">全额定金</span></el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.CollectionSet.CollectionType" :label="2"><span class="payWay-item_label">全额现结</span></el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.CollectionSet.CollectionType" :label="3">
                    <span class="payWay-item_label">限期收款</span>
                    <span>进货/开票后</span>
                    <el-input v-model="data.CollectionSet.CollectionDay" style="width: 80px" :disabled="data.CollectionSet.CollectionType !== 3"></el-input>
                    <span>天内进行收款</span>
                  </el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.CollectionSet.CollectionType" :label="4">
                    <div class="payWay-item_context">
                      <div>
                        <span class="payWay-item_label">月结</span>
                        <span>账期起始日:</span>
                        <el-date-picker
                          class="payWay-item_picker"
                          v-model="data.CollectionSet.AccountPeriodDate"
                          format="yyyy/MM/dd"
                          value-format="yyyy/MM/dd"
                          type="date"
                          placeholder="选择日期"
                          :disabled="data.CollectionSet.CollectionType !== 4"
                        >
                        </el-date-picker>
                      </div>
                      <div style="padding-top: 10px">
                        <span>每</span>
                        <el-input v-model="data.CollectionSet.AccountPeriodMonth" style="width: 80px" :disabled="data.CollectionSet.CollectionType !== 4"></el-input>
                        <span>月为一个账期,结算日期为对账后</span>
                        <el-input v-model="data.CollectionSet.SettleMonth" style="width: 80px" :disabled="data.CollectionSet.CollectionType !== 4"></el-input>
                        <span>个月的</span>
                        <el-input v-model="data.CollectionSet.SettleDay" style="width: 80px" :disabled="data.CollectionSet.CollectionType !== 4"></el-input>
                        <span>日</span>
                      </div>
                    </div>
                  </el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.CollectionSet.CollectionType" :label="5"><span class="payWay-item_label">其他</span></el-radio>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <!-- 供应商设置 -->
          <el-tab-pane label="供应商设置" name="shop" v-if="data.TradeUnitType == 1 || data.TradeUnitType == 2">
            <el-row>
              <el-col :span="12">
                <el-form-item label="默认结算方式" label-width="110px" prop="PaymentSet.SettleId">
                  <settle-select v-model="data.PaymentSet.SettleId" @change="v => (data.PaymentSet.SettleId = v)"></settle-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认账号" label-width="110px" prop="PaymentSet.AccnoutId">
                  <account-select v-model="data.PaymentSet.AccnoutId" @change="v => (data.PaymentSet.AccnoutId = v)"></account-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认票据类型" label-width="110px" prop="PaymentSet.InvoiceType">
                  <invoice-select v-model="data.PaymentSet.InvoiceType" @change="v => (data.PaymentSet.InvoiceType = v)"></invoice-select>
                  <!-- <el-select v-model="data.PaymentSet.InvoiceType">
                    <el-option :value="0" label="客户"></el-option>
                    <el-option :value="1" label="甲方"></el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
            </el-row>
            <div class="payWay">
              <strong class="payWay-title">默认付款方式</strong>
              <div class="payWay-group">
                <el-row class="payWay-item">
                  <el-radio v-model="data.PaymentSet.PaymentType" :label="1"><span class="payWay-item_label">全额定金</span> </el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.PaymentSet.PaymentType" :label="2"><span class="payWay-item_label">全额现结</span> </el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.PaymentSet.PaymentType" :label="3">
                    <span class="payWay-item_label">限期付款</span>
                    <span>进货/开票后</span>
                    <el-input v-model="data.PaymentSet.PaymentDay" style="width: 80px" :disabled="data.PaymentSet.PaymentType !== 3"></el-input>
                    <span>天内进行付款</span>
                  </el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.PaymentSet.PaymentType" :label="4">
                    <div class="payWay-item_context">
                      <div>
                        <span class="payWay-item_label">月结</span>
                        <span>账期起始日:</span>
                        <el-date-picker
                          class="payWay-item_picker"
                          v-model="data.PaymentSet.AccountPeriodDate"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy/MM/dd"
                          value-format="yyyy/MM/dd"
                          :disabled="data.PaymentSet.PaymentType !== 4"
                        >
                        </el-date-picker>
                      </div>
                      <div style="padding-top: 10px">
                        <span>每</span>
                        <el-input v-model="data.PaymentSet.AccountPeriodMonth" style="width: 80px" :disabled="data.PaymentSet.PaymentType !== 4"></el-input>
                        <span>月为一个账期,结算日期为对账后</span>
                        <el-input v-model="data.PaymentSet.SettleMonth" style="width: 80px" :disabled="data.PaymentSet.PaymentType !== 4"></el-input>
                        <span>个月的</span>
                        <el-input v-model="data.PaymentSet.SettleDay" style="width: 80px" :disabled="data.PaymentSet.PaymentType !== 4"></el-input>
                        <span>日</span>
                      </div>
                    </div>
                  </el-radio>
                </el-row>
                <el-row class="payWay-item">
                  <el-radio v-model="data.PaymentSet.PaymentType" :label="5">
                    <span class="payWay-item_label">其他</span>
                  </el-radio>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <!-- 联系方式 -->
          <el-tab-pane label="联系方式" name="mobile">
            <div class="row-tb-head">
              <div style="float: right">
                <el-button type="primary" @click="add">添加</el-button>
                <el-button type="danger" @click="del">删除</el-button>
              </div>
            </div>
            <el-table ref="table" class="table-line tb-c-head" :data="mobileList" @selection-change="handleCurrentChange" border>
              <el-table-column type="selection" width="55" />
              <el-table-column prop="Sn" label="序号" min-width="110" align="center" />
              <el-table-column prop="Address" label="地址" min-width="110" align="center" />
              <el-table-column prop="ArrivalAddress" label="到货地址" min-width="110" align="center" />
              <el-table-column prop="Person" label="联系人" min-width="110" align="center" />
              <el-table-column prop="Position" label="职位" min-width="110" align="center" />
              <el-table-column prop="Mobile" label="手机号" min-width="110" align="center" />
              <el-table-column prop="LunarBirthday" label="阴历生日" min-width="110" align="center" />
              <el-table-column prop="Birthday" label="新历生日" min-width="110" align="center" />
              <el-table-column prop="Phone" label="联系电话" min-width="110" align="center" />
              <el-table-column prop="Fax" label="传真" min-width="110" align="center" />
              <el-table-column prop="Email" label="电子邮件" min-width="110" align="center" />
              <el-table-column prop="QQ" label="QQ号" min-width="110" align="center" />
              <el-table-column prop="MSN" label="MSN" min-width="110" align="center" />
              <el-table-column prop="Wechat" label="微信号" min-width="110" align="center" />
              <el-table-column prop="Mobile" label="默认联系方式" min-width="110" align="center" />
              <el-table-column label="操作" fixed="right" align="center" width="80" key="table1_12">
                <template slot-scope="{ row }">
                  <el-button type="text" @click="editInfo(row)">修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </template>
      <!-- <template slot="footer">
        <el-button type="success" @click="save">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template> -->
    </common-dialog>
    <edit-dialog ref="editDialog" @onSelect="getMobileData"></edit-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import editDialog from './contact/editDialog.vue'
import SettleSelect from '@/components/basedata/finance/settle/select'
import paySelect from '@/components/basedata/finance/pay/select'
import invoiceSelect from '@/components/basedata/finance/invoice/select'
import accountSelect from '@/components/basedata/finance/account/select'
import areaSelect from '@/components/basedata/business/area/select'
import ditchSelect from '@/components/basedata/business/ditch/select'
import dpSelect from '@/components/basedata/personnel/dp/select'
import treeSelect from '@/components/common/treeSelect'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    editDialog,
    SettleSelect,
    paySelect,
    invoiceSelect,
    accountSelect,
    areaSelect,
    ditchSelect,
    dpSelect,
    treeSelect
  },
  data() {
    return {
      data: {
        TradeUnitId: 0,
        Code: '',
        TradeUnitNo: '',
        Name: '',
        DpId: null,
        DpName: null,
        EmpId: null,
        ShortName: '',
        TradeUnitType: null,
        ClassId: null,
        CollectionScatter: null,
        SettleUnitId: null,
        radio: null,
        CreatedDate: this.$commonJs.getToday(),
        Status: null,
        IsMember: null,
        DistrictId: null,
        AutoWriteOff: false,
        IsIncludeTax: null,
        TaxNo: '',
        FullName: '',
        LineOfCredit: null,
        ChannelId: null,
        Legal: '',
        Account: '',
        DepositBank: '',
        TaxRate: null,
        TaxRegNo: '',
        //客户设置
        CollectionSet: {
          TradeUnitId: 0,
          SettleId: null,
          AccnoutId: null,
          InvoiceType: null,
          CollectionDay: null,
          AccountPeriodDate: '',
          AccountPeriodMonth: '',
          SettleMonth: null,
          SettleDay: null,
          PaymentType: 1
        },
        //服务商设置
        PaymentSet: {
          TradeUnitId: 0,
          SettleId: null,
          AccnoutId: null,
          InvoiceType: null,
          CollectionDay: null,
          AccountPeriodDate: '',
          AccountPeriodMonth: '',
          SettleMonth: null,
          SettleDay: null,
          PaymentType: 2
        },
        // 联系方式
        Contacts: [],

        loginInfo: {QxKh: false, QxGys: false, QxKhGys: false, QxWx: false}, // <!-- h -->
      },
      isMode: '',
      is_SettleUnit: false,
      activeName: 'baseData',
      formApi: require('@/api/sy/formSetting').default,
      // 所属分类
      classApi: require('@/api/ba/class').default,
      // 供应商
      tradeUnitPaymentSetApi: require('@/api/ba/tradeUnitPaymentSet').default,
      // 客户
      tradeUnitCollectionSetApi: require('@/api/ba/tradeUnitCollectionSet').default,
      // 联系电话
      tradeUnitContactApi: require('@/api/ba/tradeUnitContact').default,
      //
      classApi: require('@/api/ba/class').default,
      // 基本信息
      api: require('@/api/ba/tradeUnit').default,
      // 部门
      dpApi: require('@/api/ent/dp').default,
      //人员
      empApi: require('@/api/ent/emp').default,
      districtApi: require('@/api/ba/district').default,
      mobileList: [],
      showList: [],
      ClassTreeData: [],
      ShopList: [],
      ClientList: [],
      unitList: [],
      currentRow: [],
      employeeList: [],
      DpTreeData: [],
      DpProps: {
        value: 'DpId',
        label: 'DpName',
        children: 'children'
      },
      ClassTreeData: [],
      ClassProps: {
        value: 'ClassId',
        label: 'ClassName',
        children: 'children'
      },
      AreaTreeData: [],
      AreaProps: {
        value: 'DistrictId',
        label: 'Name',
        children: 'children'
      },
      Mode: 1,
      code_api: require('@/api/sy/serialCode').default,
      rules: {
        TradeUnitNo: [{ required: true, message: '请输入往来单位编码' }],
        FullName: [{ required: true, message: '请输入往来单位名称' }],
        //ShortName: [{ required: true, message: "请输入简称" }],
        ClassId: [{ required: true, message: '请选择所属分类' }],
        TradeUnitType: [{ required: true, message: '请选择性质' }],
        // CreatedDate: [{ required: true, message: "请选择建档日期" }],
        // DpId: [{ required: true, message: "请选择分管部门" }],
        // EmpId: [{ required: true, message: "请选择分管人员" }],
        // DistrictId: [{ required: true, message: "请选择地区" }],
        // ChannelId: [{ required: true, message: "请选择渠道" }],
        // Account: [{ required: true, message: "请选择账号" }],
        // TaxRate: [{ required: true, message: "请输入税率" }],
        CollectionSet: {
          type: 'object',
          SettleId: [{ required: true, message: '请选择默认结算方式' }],
          AccnoutId: [{ required: true, message: '请选择默认账号' }],
          InvoiceType: [{ required: true, message: '请选择默认票据类型' }]
        },
        PaymentSet: {
          type: 'object',
          SettleId: [{ required: true, message: '请选择默认结算方式' }],
          AccnoutId: [{ required: true, message: '请选择默认账号' }],
          InvoiceType: [{ required: true, message: '请选择默认票据类型' }]
        }
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentRow = val
      console.log(this.currentRow)
    },
    // onEmpList(){
    //   this.empApi.list({}).then(res=>{
    //     this.employeeList = res.Data
    //   })
    // },
    // onComeList(){
    //   this.api.list({}).then((res) => {
    //     console.log('res.Data', res.Data);
    //     this.unitList = res.Data;
    //   });
    // },
    // 打开时获取显示显示列表
    onOpened() {
      this.activeName = 'baseData'
      let modeName = this.urlHash ? this.urlHash.split('/').join('') : location.hash.split('/').slice(1).join('')
      this.formApi.list({ type: modeName }).then(res => {
        // this.showList = res.Data?.map(x => x.ShowField)
        this.showList = res.Data?.reduce((acc, item) => {
          if (item.FormKey == item.ShowField) item.FormKey = 'Come'

          acc.push({ formKey: item.FormKey, field: item.ShowField })
          return acc
        }, [])
      })

      // this.onOpened();
      // this.onComeList();
      // // 分类
      // this.classApi.list({ ClassType: 5 }).then((res) => {
      //   this.ClassTreeData = this.arrayToTree(res.Data,'ClassId')
      // })

      this.data.loginInfo = JSON.parse(localStorage.getItem("loginInfo")); // <!-- h -->
    },
    onCreate(data) {
      this.classApi.list({ ClassType: 17 }).then(res => {
        this.ClassTreeData = this.arrayToTree(res.Data, 'ClassId')
      })
      // 部门
      this.dpApi.list({}).then(res => {
        this.DpTreeData = this.arrayToTree(res.Data, 'DpId')
      })
      this.empApi.list({}).then(res => (this.employeeList = res.Data))
      this.api.list({}).then(res => (this.unitList = res.Data))
      this.districtApi.list({}).then(res => {
        this.AreaTreeData = this.arrayToTree(res.Data, 'DistrictId')
        console.log(this.AreaTreeData)
      })
      this.code_api.previewNo('往来单位').then(res => {
        console.log('serialType', res)
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.TradeUnitNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取往来单位类别编号失败')
        }
      })
    },
    toDateStringByFormat(value, format) {
      if (!value) return ''
      let m = this.$moment(value)
      if (!m.isValid()) {
        return ''
      }
      return m.format(format)
    },
    onEditOpened(data) {
      this.api.info(data.TradeUnitId).then(res => {
        if (res.Code === 0) {
          // this.mobileList = res.Data.Contacts
          const EmpId = res.Data.EmpId
          const SettleUnitId = res.Data.SettleUnitId
          this.data = { ...res.Data, EmpId: null, SettleUnitId: null }
          this.data.CreatedDate = this.toDateStringByFormat(this.data.CreatedDate, 'YYYY-MM-DD')
          this.data.IsIncludeTax == false ? (this.data.IsIncludeTax = '否') : (this.data.IsIncludeTax = '是')
          this.mobileList = res.Data?.Contacts?.map(item => ((item.T = null), item))
          // 分类
          const item = data.IdChain ? { IdChain: data.IdChain } : {}
          this.classApi.list({ ...item, ClassType: 17 }).then(res => {
            this.ClassTreeData = this.arrayToTree(res.Data, 'ClassId')
            this.$refs.classTreeSelect.setData(this.data.ClassId)
            this.api.list({ ClassId: this.data.ClassId }).then(v => {
              this.unitList = v.Data
              this.data.SettleUnitId = SettleUnitId
            })
          })
          // 部门
          this.dpApi.list({}).then(res => {
            this.DpTreeData = this.arrayToTree(res.Data, 'DpId')
            this.$refs.dpTreeSelect.setData(this.data.DpId)
            this.empApi.list({ DpId: this.data.DpId }).then(v => {
              this.employeeList = v.Data
              this.data.EmpId = EmpId || null
            })
          })
          this.districtApi.list({}).then(res => {
            this.AreaTreeData = this.arrayToTree(res.Data, 'DistrictId')
            this.$refs.areaTreeSelect.setData(this.data.DistrictId)
          })

          this.data.loginInfo = JSON.parse(localStorage.getItem("loginInfo")); // <!-- h -->
        }
      })
    },
    onBeforeSave() {
      let InvoiceType1 = this.data.CollectionSet.InvoiceType
      this.data.CollectionSet.InvoiceType = InvoiceType1 ? InvoiceType1 : 0
      let AccnoutId1 = this.data.CollectionSet.AccnoutId
      this.data.CollectionSet.AccnoutId = AccnoutId1 ? AccnoutId1 : 0
      let SettleId1 = this.data.CollectionSet.SettleId
      this.data.CollectionSet.SettleId = SettleId1 ? SettleId1 : 0
      this.data.IsIncludeTax == '否' ? (this.data.IsIncludeTax = false) : (this.data.IsIncludeTax = true)
      let InvoiceType2 = this.data.PaymentSet.InvoiceType
      this.data.PaymentSet.InvoiceType = InvoiceType2 ? InvoiceType2 : 0
      let AccnoutId2 = this.data.PaymentSet.AccnoutId
      this.data.PaymentSet.AccnoutId = AccnoutId2 ? AccnoutId2 : 0
      let SettleId2 = this.data.PaymentSet.SettleId
      this.data.PaymentSet.SettleId = SettleId2 ? SettleId2 : 0

      if (this.data.Contacts && this.data.Contacts.length == 0) {
        this.data.Contacts = this.mobileList
      } else {
        let addList = this.mobileList.filter(item => item.T == 0)
        let editList = this.mobileList.filter(item => item.T == 1)

        let Ids = this.mobileList.map(item => item.TradeUnitContactId)
        let delList = this.data.Contacts.filter(item => {
          return !Ids.includes(item.TradeUnitContactId)
        }).map(v => ((v.T = 2), v))
        this.data.Contacts = [...addList, ...delList, ...editList]
      }
    },

    //判断显示
    iShow(type, data) {
      if (this.showList == null || this.showList.length === 0) return true
      const res = this.showList.find(item => item.formKey == type && item.field == data)
      return Boolean(res)
    },
    setting(data) {
      if (data == 1 || data == 3) {
        this.is_SettleUnit = true
        this.data.SettleUnitId = null
      }
      if (data == 3) return (this.activeName = 'baseData')
      if (data == 0) return (this.activeName = 'client')
      if (data == 2) return (this.activeName = 'client')
      if (data == 1) return (this.activeName = 'shop')
    },
    add() {
      this.isMode = 'add'
      this.tradeUnitId = this.data.TradeUnitId
      this.$refs.editDialog.openCreate()
    },
    editInfo(row) {
      this.isMode = 'edit'
      let copyRow = JSON.parse(JSON.stringify(row))
      this.$refs.editDialog.openEdit(copyRow)
    },
    del() {
      if (this.currentRow.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.currentRow.forEach(item => {
            let TradeUnitContactIds = this.mobileList.map(item => item.TradeUnitContactId)
            let index = TradeUnitContactIds.indexOf(item.TradeUnitContactId)

            if (index !== -1) {
              this.mobileList.splice(index, 1)
            }
          })
        })
        .catch(() => {})
    },
    getMobileData(data) {
      console.log(data)
      let copyData = JSON.parse(JSON.stringify(data))
      console.log('copyData', copyData)

      if (this.isMode === 'add') {
        const index = this.data.Contacts.length - 1 == -1 ? 0 : this.data.Contacts.length - 1
        // TradeUnitId
        this.mobileList.push({
          T: 0,
          TradeUnitId: this.data.TradeUnitId,
          ...copyData,
          appendix: index
        })
        console.log('mobile', this.mobileList)
      }

      if (this.isMode === 'edit') {
        console.log('edit=======')

        let obj = this.mobileList.filter(item => {
          return item.TradeUnitContactId === copyData.TradeUnitContactId
        })[0]
        obj.T = 1
        obj.Address = copyData.Address
        obj.ArrivalAddress = copyData.ArrivalAddress
        obj.Birthday = copyData.Birthday
        obj.Email = copyData.Email
        obj.Fax = copyData.Fax
        obj.IsDefault = copyData.IsDefault
        obj.LunarBirthday = copyData.LunarBirthday
        obj.Mobile = copyData.Mobile
        obj.Msn = copyData.Msn
        obj.Person = copyData.Person
        obj.Phone = copyData.Phone
        obj.Position = data.Position
        obj.Qq = copyData.Qq
        obj.Sn = copyData.Sn
        obj.TradeUnitContactId = copyData.TradeUnitContactId
        obj.TradeUnitId = copyData.TradeUnitId
        obj.Wechat = copyData.Wechat

        console.log('edit mobile', this.mobileList)
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    onDpTreeSelect(t) {
      this.data.DpName = !t ? '' : t.DpName
      this.data.DpId = !t ? null : t.DpId
      if (t) {
        if (this.data.EmpId != t.EmpId) this.data.EmpId = null
        this.empApi.list({ DpId: t.DpId }).then(res => {
          this.employeeList = res.Data
        })
      }
    },
    onClassTreeSelect(t) {
      if (!t) {
        this.data.ClassName = ''
        this.data.ClassId = null
      }
      if (t) {
        if (this.data.ClassId != t.ClassId) this.data.SettleUnitId = null
        this.data.ClassName = t.ClassName
        this.data.ClassId = t.ClassId
        this.api.list({ ClassId: t.ClassId }).then(res => {
          this.unitList = res.Data
        })
      }
    },
    onAreaTreeSelect(t) {
      this.data.DistrictId = t ? t.DistrictId : null
      this.data.Name = t ? t.Name : null
    },
    arrayToTree(items, styleId) {
      const result = [] // 存放结果集
      const itemMap = {} //
      for (const item of items) {
        const id = item[styleId]
        const pid = item.Pid

        if (!itemMap[id]) {
          itemMap[id] = {
            children: []
          }
        }

        itemMap[id] = {
          ...item,
          children: itemMap[id]['children']
        }

        const treeItem = itemMap[id]

        if (pid === 0) {
          result.push(treeItem)
        } else {
          if (!itemMap[pid]) {
            itemMap[pid] = {
              children: []
            }
          }
          itemMap[pid].children.push(treeItem)
        }
      }
      return result
    },
    onClosed() {
      this.mobileList = []
      this.showList = []
      this.ClassTreeData = []
      this.ShopList = []
      this.ClientList = []
      this.unitList = []
      this.currentRow = []
      this.unitList = []
      this.employeeList = []
      this.DpTreeData = []
      this.ClassTreeData = []
      this.AreaTreeData = []
      this.data.CollectionSet = {}
      this.data.PaymentSet = {}
      this.data.Contacts = []
      this.$refs.dpTreeSelect.clearHandle()
      this.$refs.areaTreeSelect.clearHandle()
      this.$refs.classTreeSelect.clearHandle()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #fff;
}

/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}

.baseData-title {
  padding: 5px 0;
}

.payWay {
  // .payWay-title {}

  .payWay-group {
    padding-left: 5px;

    .payWay-item {
      padding-top: 10px;

      letter-spacing: 1px;

      .payWay-item_label {
        margin-right: 10px;
        color: #606266 !important;
      }

      span {
        color: #333;
      }

      /deep/ .el-input .el-input__inner {
        border: none;
        border-bottom: 1px solid #dcdfe6;
      }

      /deep/ .payWay-item_picker .el-input__inner {
        height: 18px;
      }

      /deep/ .payWay-item_picker .el-icon-date {
        line-height: 10px;
      }

      .payWay-item_context {
        display: inline-block;
        vertical-align: top;
      }
    }
  }
}
</style>
